import { render, staticRenderFns } from "./WaterParameter.vue?vue&type=template&id=4087f869&"
import script from "./WaterParameter.vue?vue&type=script&lang=js&"
export * from "./WaterParameter.vue?vue&type=script&lang=js&"
import style0 from "./WaterParameter.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports